import { AppInsights } from 'applicationinsights-js';
import { environment } from 'environments/environment';
function gtmSend(type, data) {
    if (typeof ga === 'function') {
        var result = ga && ga('send', type, data);
        var tracker = ga && ga.getAll()[0];
        if (tracker) {
            tracker.send(type, data);
        }
    }
}
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
        this.config = {
            instrumentationKey: environment.appInsightsKey
        };
        if (!AppInsights.config) {
            AppInsights.downloadAndSetup(this.config);
        }
        this.AppInsights = {
            eventPage: this.eventAppInsightsPageView,
            event: this.eventAppInsights,
            authUser: this.setAuthenticatedUser
        };
        this.GTM = {
            head: function (after) {
                if (after === void 0) { after = null; }
                (function (w, d, s, l, tkGTM) {
                    w[l] = w[l] || [];
                    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    var f = d.getElementsByTagName(s)[0], sGTM = d.createElement(s), GTMIframe = d.createElement('iframe'), dl = l !== 'dataLayer' ? '&l=' + l : '';
                    var g = document.getElementsByTagName('noscript')[0];
                    if (!g)
                        g = document.createElement('noscript');
                    GTMIframe.src = 'https://www.googletagmanager.com/ns.html?id=' + tkGTM;
                    GTMIframe.height = '0';
                    GTMIframe.width = '0';
                    GTMIframe.setAttribute('style', 'display:none;visibility:hidden;');
                    sGTM.async = true;
                    sGTM.src = 'https://www.googletagmanager.com/gtm.js?id=' + tkGTM + dl;
                    f.parentNode.insertBefore(sGTM, f);
                    g.appendChild(GTMIframe);
                    if (d) {
                        d.head.appendChild(sGTM);
                        d.body.appendChild(g);
                    }
                    if (after)
                        sGTM.onload = function () {
                            after();
                        };
                })(window, document, 'script', 'dataLayer', environment.google.GTM.token);
            },
            event: this.gtmEvent,
            hash: this.gtmHashChanged
        };
    }
    AnalyticsService.prototype.eventAppInsightsPageView = function (name, url, properties, measurements, duration) {
        AppInsights.trackPageView(name, url, properties, measurements, duration);
    };
    AnalyticsService.prototype.setAuthenticatedUser = function (authenticatedUserId, accountId, storeInCookie) {
        if (storeInCookie === void 0) { storeInCookie = true; }
        AppInsights.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
    };
    AnalyticsService.prototype.eventAppInsights = function (name, properties, measurements) {
        AppInsights.trackEvent(name, properties, measurements);
    };
    AnalyticsService.prototype.gtmEvent = function (categoria, accion, label) {
        if (typeof ga !== 'undefined' && typeof ga.getAll === 'function') {
            var tracker = ga && ga.getAll()[0];
            if (tracker) {
                tracker.send('event', categoria, accion, label);
            }
        }
    };
    AnalyticsService.prototype.gtmHashChanged = function (loc) {
        gtmSend('pageview', { page: loc });
    };
    AnalyticsService.prototype.setGTMUser = function (ID) {
        this.gtmSet('userId', ID);
    };
    AnalyticsService.prototype.gtmSet = function (type, data) {
        if (typeof ga !== 'undefined') {
            ga('set', type, data);
        }
    };
    return AnalyticsService;
}());
export { AnalyticsService };
